<template>
    <div class="tab-pane"
        :class="{active}"
        :id="'tab_' + form.type" >
        <confirmation-card
                v-bind:showPopup="showPopup"
                v-bind:textPopup="$t('Controls.text18')"
                @confirmation="confirmationHandler"
        > </confirmation-card>
        <div class="col-xs-12 well">
        <h1>
            {{translate('Controls.' + form.title.replace(/ /g, ""), form.title)}}
             <button v-if="!form.hideAddButton" class="btn btn-primary"
                :title="translate('Form.text3')"
                @click="addEntity">
                <span class="glyphicon glyphicon-plus"></span>
            </button>
        </h1>

        <table class="table">
            <thead>
                <tr>
                    <th>{{translate("Controls.Edit", "Edit")}}</th>
                    <th v-for="property in form.properties" :key="property.property">{{translate('Controls.' + property.title.replace(/ /g, ""), property.title)}}</th>
                    <th>{{translate("Controls.Smaž", "Smaž")}}</th>
                </tr>
            </thead>
            <tbody>
            <tr v-for="(dataRow, i) in form.data" :key="'record'+i">
                <td>
                <button type="button" class="btn btn-primary" :title="translate('Form.text4')"
            @click="openEditModal(dataRow.entityId)">
                <span class="glyphicon glyphicon-pencil"></span>
                </button>
                </td>
                <td v-for="property in form.properties"  v-bind:key="property.property">
                    <template
                            v-if="property.type === 'gps' && Array.isArray(getPropertyValue(dataRow, property.property))">
                        {{formatGps(getPropertyValue(dataRow, property.property))}}
                    </template>
                    <template v-else-if="Array.isArray(getPropertyValue(dataRow, property.property))">
                        {{localeSort(getPropertyValue(dataRow, property.property)).join(', ')}}
                    </template>
                    <template v-else-if="property.linked">
                        {{getSafeLabel(property.extension.options.find(x => x.value === getPropertyValue(dataRow, property.property)))}}
                    </template>
                    <template v-else>
                        {{getPropertyValue(dataRow, property.property)}}
                    </template>

                </td>
                <td v-if="allowDelete" >
                    <button type="button" class="btn btn-primary" :title="$t('Form.text5')"
                    v-on:click="confirmationHandler(null, dataRow.id, false)">
                        <span class="glyphicon glyphicon-remove"></span>
                        </button>
                </td>
            </tr>
            </tbody>
        </table>

        </div>
        <modal v-if="modalActive"
            @close="modalActive = false">
            <div class="modal-header">
                <h4 v-if="modalCreate" class="modal-title" id="modal_Label">{{translate('Form.text6')}}</h4>
                <h4 v-else class="modal-title" id="modal_Label">{{translate('Form.text7')}}</h4>
            </div>
            <div class="modal-body">

                <div class="row">
                    <dynamic-form-property
                        v-for="property in form.properties"
                            :key="property.property"
                        v-bind="{
                            inputType: property.type, // set 'select'
                            inputNumberMin: property.min,
                            labelName: translate('Controls.' + property.title.replace(/ /g, ''), property.title),
                            dataEntityId: modalDataRow.entityId,
                            dataProperty: property.property,
                            dataAttr: {},
                            dataCss: {},
                            entity: modalDataRow,
                            extension: property.extension
                        }"
                        @valueChange="valueChange">
                    </dynamic-form-property>

                </div>
            </div>
        </modal>
    </div>
</template>

<script>

import modal from '@/components/modal.vue';
import GpsFormat from "../utils/GpsFormat";
import getPropertyValue from "./getPropertyValue";
import confirmationCard from "../components/confirmationCard";
import DynamicFormProperty from "../components/form/dynamicFormProperty";

export default {
    name: 'dynamicForm',
    data: function(){
        return {
            modalEntityId: undefined,
            modalActive: false,
            modalCreate: false, // Create new record:Edit record
            showPopup: false,
            rowToDelete: null
        }
    },
    components: {
        DynamicFormProperty,
        modal,
        confirmationCard
    },
    computed: {
        getSimId() {
            if (this.$route.params.simId === undefined) {
                return parseInt(this.$store.state.simId);
            } else {
                return parseInt(this.$route.params.simId);
            }
        }
    },
    methods: {
        formatGps: GpsFormat.formatGps,
        getSafeLabel(item) {
            if(item && item.hasOwnProperty("label")) {
                return item.label;
            }
            return "";
        },
        confirmationHandler: function(yes, row, closePopup) {
            /**
             * Handle response from popup
             * */
            if (row && yes === null) {
                this.rowToDelete = row;
                this.showPopup = true;
            }
            if (yes) {
                this.deleteRow(this.rowToDelete);
            }
            if (closePopup) {
                this.showPopup = false;
            }
        },
        getPropertyValue,
        createNew() {
            console.log(`Create ${this.form.type} record`);
        },
        async deleteRow(entityId) {
            console.log("deleting..")
            await this.$store.dispatch('callApi', {
                name: 'removeEntity',
                payload: {entityId, simId: this.getSimId}
            });
            this.$emit('reload');
            console.log(`Delete ${this.form.type}/${entityId} record`);
        },
        activateBtn() {
            this.saveBtnState = "";
        },
        getSelectedValue(value,property) {
            if (!value) {
                return '';
            }
            try {
                return property.options.find((a) => {
                    return a.id == value;
                }).text;
            } catch (e) {
                return undefined;
            }
        },
        openEditModal(entityId){
            this.modalEntityId = entityId;
            this.modalActive = true;
            this.modalCreate = false;
        },
        saveModalRecord(){
            if(this.modalCreate){
                this.createNew()
            } else {
                this
            }
        }
    },
    mounted() {
    }
}
</script>

<style lang="less" scoped>

</style>
